// sessionStorage에서 특정 키의 데이터 조회 (JSON 파싱)
export const getItemFromSessionStorage = <T = any>(key: string): T | null => {
  try {
    const stored = sessionStorage.getItem(key);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error(`Failed to get ${key} from sessionStorage:`, error);
  }
  return null;
};

// sessionStorage에 특정 키로 데이터 저장 (JSON 직렬화)
export const setItemToSessionStorage = <T = any>(key: string, value: T): void => {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`Failed to set ${key} to sessionStorage:`, error);
  }
};

// sessionStorage에서 특정 키의 데이터 삭제
export const removeItemFromSessionStorage = (key: string): void => {
  try {
    sessionStorage.removeItem(key);
  } catch (error) {
    console.error(`Failed to remove ${key} from sessionStorage:`, error);
  }
};

// sessionStorage에서 모든 데이터 삭제
export const clearSessionStorage = (): void => {
  try {
    sessionStorage.clear();
  } catch (error) {
    console.error('Failed to clear sessionStorage:', error);
  }
};

// OnBoarding 관련 상수 (편의를 위해)
export const ONBOARDING_KEYS = {
  DATA: 'onboarding_data',
  STEP: 'onboarding_step'
} as const;
